import ApiUtil from './ApiUtil';

export function getTicker(tickerArr, frequency, start, end, isPercent, product, isRolling) {
  const instrumentStr = tickerArr.reduce((str, item) => str + `instrument=${item.chartingSymbol}&`, '');
  const format = isPercent ? 'percent' : 'value';
  const type = isRolling ? 'rolling' : 'fixed';
  const props = { frequency, start, end, format, product, type };
  const propsStr = Object.keys(props).reduce((str, prop) => str + `${prop}=${props[prop]}&`, '').slice(0, -1);
  return ApiUtil.get(`/api/v2/mike?${instrumentStr}${propsStr}`);
}



// WEBPACK FOOTER //
// ./src/ui/util/getTicker.js